import { makeStyles } from "@material-ui/core/styles";
import { useRecoilValue } from "recoil";
import { weatherTimeWithID, WX_ID_ACOS } from "../../../store/WeatherContentsState";
import greenImg from "../../../images/contents/map/acos/green.png"
import orangeImg from "../../../images/contents/map/acos/orange.png"
import redImg from "../../../images/contents/map/acos/red.png"
import yellowImg from "../../../images/contents/map/acos/yellow.png"

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    justifyContent: 'flex-start',
    marginBottom: '3px'
  },
  columnBox: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px',
    display: 'flex',
    alignItems: 'center'
  },
  checkLabel: {
    display: 'inline-block',
    width: '62px',
    textAlign: 'left',
    fontSize:"12px"
  },
  iconWrap: {
    width: "35px",
    display: "inline-block"
  },
  icon: {
    verticalAlign: "middle"
  },
  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    whiteSpace: "nowrap"
  },
  legendBase: {
    display: "inline-block",
    height: 10,
    width: 30,
    border: 'solid 2px'
  },
  ft03: {
    backgroundColor: "rgba(220, 107, 44, 0.5)",
    borderColor: "rgba(220, 107, 44, 1.0)"
  },
  ft06: {
    backgroundColor: "rgba(234, 100, 255, 0.5)",
    borderColor: "rgba(234, 100, 255, 1.0)"
  },
  ft09: {
    backgroundColor: "rgba(76, 158, 8, 0.5)",
    borderColor: "rgba(76, 158, 8, 1.0)"
  },
  ft12: {
    backgroundColor: "rgba(255, 255, 0, 0.5)",
    borderColor: "rgba(255, 255, 0, 1.0)"
  },
  ft15: {
    backgroundColor: "rgba(73, 221, 194, 0.5)",
    borderColor: "rgba(73, 221, 194, 1.0)"
  },
  ft18: {
    backgroundColor: "rgba(35, 110, 241, 0.5)",
    borderColor: "rgba(35, 110, 241, 1.0)"
  },
  ft21: {
    backgroundColor: "rgba(197, 78, 160, 0.5)",
    borderColor: "rgba(197, 78, 160, 1.0)"
  },
  ft24: {
    backgroundColor: "rgba(106, 55, 167, 0.5)",
    borderColor: "rgba(106, 55, 167, 1.0)"
  },
  detachedVa: {
    borderColor: "rgba(250, 150, 50, 1.0)",
    backgroundImage: `linear-gradient(
      -45deg,
      rgba(255,255,255, 0) 40%,
      rgba(250, 150, 50, 1) 40%, rgba(250, 150, 50, 1) 50%,
      rgba(255,255,255, 0) 50%, rgba(255,255,255, 0) 90%,
      rgba(250, 150, 50, 1) 90%, rgba(250, 150, 50, 1)
    )`,
    backgroundSize: "7px 7px"
  },
}));

function LegendAcos() {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_ACOS));

  return (
    <div>
      <div className="legend-contents-time">
        {timeInfo.validTime}
      </div>
      <div className={classes.box}>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft03}`}></span><span className={classes.label}>FT03H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft06}`}></span><span className={classes.label}>FT06H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft09}`}></span><span className={classes.label}>FT09H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft12}`}></span><span className={classes.label}>FT12H</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft15}`}></span><span className={classes.label}>FT15H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft18}`}></span><span className={classes.label}>FT18H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft21}`}></span><span className={classes.label}>FT21H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft24}`}></span><span className={classes.label}>FT24H</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.detachedVa}`}></span><span className={classes.label}>Detached VA from previous eruption</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={classes.label}>ACOS Monitored Volcanoes</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={`${classes.iconWrap} acos-legend-tooltip`}>
              <img src={greenImg} alt="green" className={classes.icon}></img>
              <span className="acos-legend-tooltip-text">
                Ash<br></br>
                Volcano is in a non-eruptive state. Or, after a change from a higher alert level<br></br>
                Volcanic activity considered to have ceased, and volcano reverted to a non-eruptive state.<br></br>
                <br></br>
                Non Ash<br></br>
                Volcano is in a non-eruptive state. Or, after a change from a higher alert level<br></br>
                Volcanic activity considered to have ceased, and volcano reverted to a non-eruptive state.
              </span>
            </span>
            <span className={`${classes.iconWrap} acos-legend-tooltip`}>
              <img src={yellowImg} alt="yellow" className={classes.icon}></img>
              <span className="acos-legend-tooltip-text">
                Ash<br></br>
                Volcano is experiencing signs of elevated unrest above known background levels<br></br>
                Or, after a change from a higher alert level;Volcanic activity has decreased significantly but continues to be closely monitored for possible renewed increase.<br></br>
                <br></br>
                Non Ash<br></br>
                Volcano is experiencing signs of elevated unrest above known background levels. Ash emission has not resulted from any activity.
              </span>
            </span>
            <span className={`${classes.iconWrap} acos-legend-tooltip`}>
              <img src={orangeImg} alt="orange" className={classes.icon}></img>
              <span className="acos-legend-tooltip-text">
                Ash<br></br>
                Volcano is exhibiting heightened unrest considered to be typical, with increased likelihood of an eruption.<br></br>
                Or volcanic eruption is underway with a max top under FL200 with no or minor ash emission.<br></br>
                <br></br>
                Non Ash<br></br>
                NIL
              </span>
            </span>
            <span className={`${classes.iconWrap} acos-legend-tooltip`}>
              <img src={redImg} alt="red" className={classes.icon}></img>
              <span className="acos-legend-tooltip-text">
                Ash<br></br>
                Eruption is forecast to be imminent with significant emission of ash into the atmosphere likely, Or eruption is underway with significant emission of ash into the atmosphere<br></br>
                (over FL250 for South & Central America, and over FL200 for other regions or volcanic ash is near an airport).<br></br>
                <br></br>
                Non Ash<br></br>
                NIL
              </span>
            </span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
              <span className={classes.label}>The volcanic rank of ACOS does not mean volcanic activity but the impact for aviation.</span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default LegendAcos;
